module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_arrow_right06-0d18ced35af8c4a6d030b8a8322601ae.svg";